import crypto from 'node:crypto';
export default {
  randomUUID: crypto.randomUUID
};